import React from 'react';
import { useEventEmitter } from '@edreamsodigeo/frontend-checkout';
import { PrimeEventManagerProvider } from '@edreamsodigeo/frontend-prime';
import PropTypes from 'prop-types';
const PrimeEventManagerProviderComposition = ({
  children
}) => {
  const useExternalEventEmitter = event => useEventEmitter(event);
  return /*#__PURE__*/React.createElement(PrimeEventManagerProvider, {
    externalEventEmitter: useExternalEventEmitter
  }, children);
};
PrimeEventManagerProviderComposition.propTypes = {
  children: PropTypes.node.isRequired
};
export default PrimeEventManagerProviderComposition;